import * as React from "react";
import styled from "@mui/material/styles/styled";
import List from "@mui/material/List";
import { PatientChartVitalSignsFindings } from "./PatientChartVitalSignsFindings";
import { KahunPanelSubGroup } from "shared";
import {
  DataInputSectionConfigurations,
  getContainedSubGroup,
} from "../config/dataInputSectionConfiguration";
import { PatientChartSection } from "./PatientCaseContainer";
import { getPatientFindingsSection, usePatientCase } from "../usePatientCase";
import { PatientCaseGrouping } from "../../../context/diagnosticAgent";
import { groupBy } from "fe-common/ui/arrayUtils";

//region [[ Styles ]]

const PatientChartVitalSignsDesktopView = styled("div")(({ theme }) => ({}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartVitalSignsDesktopProps {
  gotoDataInput?: (
    panel: PatientCaseGrouping,
    categoryid?: string,
    toMyPatient?: boolean,
  ) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientChartVitalSignsDesktop = ({
  ...props
}: PatientChartVitalSignsDesktopProps) => {
  const { handleChipRemove, patientCase } = usePatientCase();
  const remove = (f) =>
    handleChipRemove(f, PatientCaseGrouping.CLINICAL_FEATURES);

  const qfs = getPatientFindingsSection(
    PatientCaseGrouping.CLINICAL_FEATURES,
    patientCase,
  ).filter((qf) => !qf.skip);
  const qfsGrouped = groupBy(
    qfs,
    (qf) => getContainedSubGroup(qf, PatientCaseGrouping.CLINICAL_FEATURES).id,
  );

  const vitalSignsFindings = qfsGrouped[KahunPanelSubGroup.VitalSign];

  return (
    <PatientChartVitalSignsDesktopView>
      {vitalSignsFindings && vitalSignsFindings.length > 0 && (
        <List component="nav" style={{ paddingTop: "0" }}>
          <PatientChartSection
            style={{
              //TODO: move inline style to styled component
              borderBottom: "none",
            }}
          >
            <PatientChartVitalSignsFindings
              remove={remove}
              subGroupId={KahunPanelSubGroup.VitalSign}
              gotoSection={() => {
                props.gotoDataInput(
                  PatientCaseGrouping.VITAL_SIGNS,
                  KahunPanelSubGroup.VitalSign,
                  DataInputSectionConfigurations[KahunPanelSubGroup.VitalSign]
                    .hasMyPatient,
                );
              }}
              onRefine={null}
            />
          </PatientChartSection>
        </List>
      )}
    </PatientChartVitalSignsDesktopView>
  );
};
